import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

const missingVars = [
  !supabaseUrl && 'REACT_APP_SUPABASE_URL',
  !supabaseAnonKey && 'REACT_APP_SUPABASE_ANON_KEY',
].filter(Boolean) as string[];

export const supabaseConfigError = missingVars.length
  ? `Supabase configuration missing: ${missingVars.join(', ')}. Add them to your environment (local .env / hosting secrets).`
  : null;

if (supabaseConfigError && process.env.NODE_ENV === 'development') {
  console.error(supabaseConfigError);
}

export const supabase = supabaseConfigError ? null : createClient(supabaseUrl!, supabaseAnonKey!);

// Database types
export interface Job {
  id?: string;
  title_nl: string;
  title_en: string;
  discipline: string;
  location: string;
  salary: string;
  description_nl?: string;
  description_en?: string;
  posted_date: string;
  deadline_date?: string;
  uploader_email: string;
  image_url?: string;
  type: string;
  created_at?: string;
  updated_at?: string;
}

export interface Application {
  id?: string;
  job_id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  cv_url: string;
  cover_letter?: string;
  linkedin_url?: string;
  status?: 'new' | 'reviewed' | 'shortlisted' | 'rejected' | 'hired';
  created_at?: string;
  updated_at?: string;
}

